import { Injectable } from '@angular/core';
import {Subject, Observable} from 'rxjs';

import {ApiService} from './api.service';
import {User} from './user.model';
    
@Injectable()
export class UserSettingsService {
    settings = {
        menuColumnToggle: true,
        notificationColumnToggle: true,
        slideColumnToggle: true,
        widgetColumnToggle: true,
        editArticleToggle: true,
        prePublishToggle: true,
        slidePreviewToggle: false,
        pageAdditionsToggle: true,
        articleDetailsToggle: true,
        articleNotesToggle: true,
        revisionNotesToggle: true
    };

    constructor(private api: ApiService) {
        this.loadSettings();
    }
    loadSettings() {
        try {
            let userSettings = JSON.parse(localStorage.getItem('userSettings'));
            for(var setting in userSettings ) {
                this.settings[setting] = userSettings[setting];
            }
        } catch(e) {
            console.log('Failed loading user settings.', e);
        }
    }
    toggle(setting) {
        this.settings[setting] = !this.settings[setting];
        if( setting == 'slidePreviewToggle' && this.settings.slidePreviewToggle ) {
            this.settings.slideColumnToggle = true;
        }
        if( setting == 'slideColumnToggle' && !this.settings.slideColumnToggle ) {
            this.settings.slidePreviewToggle = false;
        }
        this.saveSettings();
    }
    saveSettings() {
        localStorage.userSettings = JSON.stringify(this.settings);
    }
}



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/user-settings.service.ts